import { kebabCase } from 'lodash';

import { Style } from './types';

/**
 * Merges a "style" object of CSS properties into an element's current styling
 */
export const applyStyleToElement = (style: Style, element: HTMLElement) =>
  Object.entries(style).forEach(([property, value]) =>
    element.style.setProperty(kebabCase(property), value?.toString() ?? null),
  );
